// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"9d3c31aa9272a54cfb9d","575":"8f9df04ebf898f855e8d","671":"20ce37effbeec5305baa"}[chunkId] + ".js";
};